import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "skill-dice-roll" }
const _hoisted_2 = { class: "skill-dice-roll__roll-type-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.rollTypes), (type) => {
          return (_openBlock(), _createElementBlock("li", { key: type }, [
            _createVNode(_component_Button, {
              secondary: _ctx.rollType !== type,
              onClick: ($event: any) => (_ctx.changeRollType(type))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`roll-type__${type}`)), 1)
              ]),
              _: 2
            }, 1032, ["secondary", "onClick"])
          ]))
        }), 128))
      ])
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
      key: _ctx.rollType,
      "roll-type": _ctx.rollType,
      skill: _ctx.skill
    }, null, 8, ["roll-type", "skill"]))
  ]))
}